var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "py-4 flex relative",
      attrs: { id: `question_${_vm.index + 1}` },
    },
    [
      _c(
        "span",
        {
          staticClass:
            "w-20 py-5 px-2 text-3xl leading-relaxed absolute transform -translate-y-3 lg:px-6 lg:translate-y-0",
        },
        [_vm._v(_vm._s(_vm.index + 1))]
      ),
      _c("div", { staticClass: "min-w-0 pl-14 py-3 flex-1 lg:pl-20 lg:py-5" }, [
        _c("div", { staticClass: "-ml-20 pl-20 flex items-center gap-x-2" }, [
          _c("div", { staticClass: "flex-1 relative" }, [
            _c(
              "p",
              {
                staticClass:
                  "w-full rounded-lg py-2 px-4 bg-gray-100 font-bold",
              },
              [_vm._v(_vm._s(_vm.question__user.questionTitle))]
            ),
            _vm.question.correctAnswerCnt > 1
              ? _c("div", { staticClass: "absolute -top-5" }, [
                  _c("p", { staticClass: "text-xs text-red-400" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("exam.question.score", {
                          0: _vm.question.correctAnswerCnt,
                        })
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm.bankExam.examType === "QUIZ"
            ? _c(
                "div",
                { staticClass: "flex items-center gap-x-0.5" },
                [
                  _c("GrmTextField", {
                    staticClass: "w-20",
                    attrs: { type: "number", disabled: "" },
                    model: {
                      value: _vm.question__user.questionScore,
                      callback: function ($$v) {
                        _vm.$set(_vm.question__user, "questionScore", $$v)
                      },
                      expression: "question__user.questionScore",
                    },
                  }),
                  _c("span", { staticClass: "text-xs" }, [
                    _vm._v(_vm._s(_vm.$t("exam.question.point"))),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "mt-2 flex flex-col gap-y-1 relative" },
          _vm._l(_vm.question__user.answerList, function (answer, i) {
            return _c("div", { key: i, staticClass: "gap-x-1" }, [
              _c(
                "div",
                {
                  staticClass:
                    "min-w-0 max-w-max flex-1 rounded flex items-baseline gap-x-2",
                },
                [
                  _c("div", { staticClass: "relative" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "w-5 h-5 border rounded-full flex justify-center items-center text-sm select-none transition",
                        class: [
                          answer.correct && _vm.showAnswer
                            ? "border-blue-400 bg-blue-400 text-white"
                            : "border-gray-800",
                          { "pointer-events-none": _vm.hasEmceeRole() },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.onSelectAnswer(answer)
                          },
                        },
                      },
                      [_vm._v(_vm._s(i + 1))]
                    ),
                    false
                      ? _c("span", {
                          staticClass:
                            "w-5 h-5 bg-exam-check-red block absolute -top-2.5 -left-0.5 pointer-events-none",
                        })
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "flex flex-col gap-y-1" }, [
                    _c(
                      "p",
                      {
                        staticClass:
                          "min-w-0 max-w-max flex-1 rounded-lg py-2 px-3 bg-gray-100 text-xs",
                      },
                      [_vm._v(_vm._s(answer.answerTitle))]
                    ),
                    _vm.hasEmceeRole()
                      ? _c(
                          "div",
                          { staticClass: "flex flex-wrap gap-2" },
                          _vm._l(
                            _vm.submitUserList(answer),
                            function (submitUser, i) {
                              return _c(
                                "div",
                                {
                                  key: i,
                                  staticClass:
                                    "flex items-center flex-wrap gap-2",
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "w-max rounded px-2 bg-gray-200 text-xs text-gray-800 font-bold leading-6",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          submitUser ||
                                            _vm.$t("exam.unknownUser")
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
            ])
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }